import { Pricing } from "landing";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import { useEffect } from "react";
import { sendPricingPageViewEvent } from "tag-manager";

const PricingPage: NextPage = () => {
	useEffect(() => {
		sendPricingPageViewEvent();
	}, []);

	return (
		<>
			<NextSeo
				title="Mango GIS - Pricing"
				description="Start for free with a no-obligation free trial account."
			/>
			<Pricing />
		</>
	);
};

export default PricingPage;
